const extractUrl = (value: unknown): string | undefined => {
  if (typeof value === 'string') return value;
  if (value && typeof value === 'object') {
    const record = value as { url?: unknown; path?: unknown };
    if (typeof record.url === 'string') return record.url;
    if (typeof record.path === 'string') return record.path;
  }
  return undefined;
};

export const isLocalPublicAssetPath = (value?: string): boolean =>
  typeof value === 'string' && (
    value.startsWith('assets/accessory/') ||
    value.startsWith('assets/clothing/') ||
    value.startsWith('assets/pet/') ||
    value.startsWith('/assets/accessory/') ||
    value.startsWith('/assets/clothing/') ||
    value.startsWith('/assets/pet/')
  );

interface ViewerAssetShape {
  files?: Record<string, unknown> | null;
  preview_files?: Record<string, unknown> | null;
  ai_result?: Record<string, unknown> | null;
}

/**
 * Shared source selector for model viewers.
 * - Owners/purchasers may use full-res.
 * - Public/logged-out users must use protected/public preview assets only.
 */
export function selectViewerGlb(asset: ViewerAssetShape | null | undefined, canUseFullRes: boolean): string | undefined {
  if (!asset) return undefined;

  const files = (asset.files ?? {}) as Record<string, unknown>;
  const previewFiles = (asset.preview_files ?? {}) as Record<string, unknown>;
  const aiResult = (asset.ai_result ?? {}) as Record<string, unknown>;
  const storagePaths = (aiResult.storage_paths ?? {}) as Record<string, unknown>;
  const previewStoragePaths = (storagePaths.preview_assets ?? {}) as Record<string, unknown>;

  const previewGlb =
    extractUrl(previewStoragePaths?.glb) ||
    extractUrl(previewStoragePaths?.roblox_glb) ||
    extractUrl(previewFiles.glb) ||
    extractUrl(previewFiles.low_glb) ||
    extractUrl(previewFiles.lowres) ||
    extractUrl(previewFiles.lowres_url) ||
    extractUrl(files.low_glb);

  const fullGlb =
    extractUrl(files.glb) ||
    extractUrl(files.low_glb) ||
    extractUrl(files.model);

  if (canUseFullRes) {
    return fullGlb || previewGlb;
  }

  return previewGlb || (isLocalPublicAssetPath(fullGlb) ? fullGlb : undefined);
}
